import { types } from "./actionTypes";

// creating action
export const getDashboard = (callback: any) => {
  return {
    type: types.GET_DASHBOARD,
    callback,
  };
};
